import { render, staticRenderFns } from "./StatsAttributionTable.vue?vue&type=template&id=4cf92868"
import script from "./StatsAttributionTable.vue?vue&type=script&lang=js"
export * from "./StatsAttributionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports